import { Wallet } from "lucide-react";
import { useUser } from "../../hooks/useUser";
import { BASE_TRACKER_URL } from "../../utils/constants";
import BetaBadge from "../ui/BetaBadge";

const ProfileCard: React.FC = () => {
  const { user } = useUser();

  if (!user) {
    return null;
  }

  const handleNavigateToDashboard = () => {
    window.location.href = "https://www.cointribune.com/profil";
  };

  return (
    <div
      className="flex gap-4 items-start p-4 bg rounded relative w-full cursor-pointer"
      onClick={handleNavigateToDashboard}
    >
      <div
        className="flex justify-center items-center w-14 h-14 rounded-full overflow-hidden shrink-0"
        style={{ minWidth: "3.5rem" }}
      >
        <img
          src={user.profilePicture || `${BASE_TRACKER_URL}/avatar.png`}
          className="object-cover w-full h-full"
          alt="user profile"
        />
      </div>
      <div
        className="flex"
        style={{
          flexDirection: "column",
          gap: 0,
          margin: 0,
          padding: 0,
          position: "relative",
          top: 0,
          alignSelf: "flex-start",
          minWidth: 0,
          flex: 1,
        }}
      >
        <h1
          className="truncate max-w-full"
          title={user.username}
          style={{
            fontSize: "1.5rem",
            fontWeight: 700,
            color: "var(--color-white)",
            lineHeight: 1,
            margin: 0,
            padding: 0,
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {user.username}
        </h1>
        <div
          className="flex"
          style={{
            gap: "0.3rem",
            alignItems: "center",
            margin: 0,
            padding: 0,
            marginTop: "0.35rem",
          }}
        >
          <Wallet className="text-white" size={18}></Wallet>
          <div style={{ backgroundColor: "white", width: 2, height: 16 }}></div>
          <span
            style={{
              fontSize: ".8rem",
              fontWeight: 500,
              color: "white",
              margin: 0,
              padding: 0,
            }}
          >
            {user.points}
          </span>
          <img
            src={`${BASE_TRACKER_URL}/coin.svg`}
            alt="coin"
            style={{
              width: "1rem",
              height: "1rem",
              minWidth: "1rem",
              marginLeft: "0.1rem",
              display: "inline-block",
              verticalAlign: "middle",
            }}
          />
        </div>
      </div>
      <div className="absolute bottom-2 right-2">
        <BetaBadge />
      </div>
    </div>
  );
};

export default ProfileCard;
